import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';

import { Invoices } from '@/features/invoices/Invoices';
import PageLayout from '@/layout/PageLayout';

export default function InvoicesPage() {
    return (
        <ApplicationLayout.Body>
            <PageLayout>
                <Invoices />
            </PageLayout>
        </ApplicationLayout.Body>
    );
}
